/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис реализует функционал управления зонами доступа
 */

/**
 * Сервис зон доступа
 */
export class AccessZoneServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения зоны доступа.
   * Поддерживает создание и обновление.
   * Для пользователей типов owner, employee можно создать и редактировать зону доступа только в квартирограмме, относящейся к компании пользователя.
   * Метод доступен для: admin, service, bti, ltp_first, device_admin, manager, owner, employee
   */
  PostAccessZone = (req: PostAccessZoneRequestDto, init?: RequestInit): Promise<PostAccessZoneResponseDto> => {
    return fm.request<PostAccessZoneRequestDto, PostAccessZoneResponseDto>(`${this.host}/access_control/api/v1/access_zone`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения зоны доступа по идентификатору.
   * Для пользователей типов owner, employee возвращаются только зоны доступа, относящиеся к компании пользователя.
   * Метод доступен для: admin, service, bti, ltp_first, device_admin, manager, owner, employee
   */
  GetAccessZone = (req: GetAccessZoneRequestDto, init?: RequestInit): Promise<GetAccessZoneResponseDto> => {
    return fm.request<GetAccessZoneRequestDto, GetAccessZoneResponseDto>(`${this.host}/access_control/api/v1/access_zone/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка зон доступа.
   * Для пользователей типов owner, employee возвращаются только зоны доступа, относящиеся к компании пользователя.
   * Метод доступен для: admin, service, bti, ltp_first, device_admin, manager, owner, employee
   */
  GetAccessZoneList = (req?: GetAccessZoneListRequestDto, init?: RequestInit): Promise<GetAccessZoneListResponseDto[]> => {
    return fm.list<GetAccessZoneListRequestDto, GetAccessZoneListResponseDto>(`${this.host}/access_control/api/v1/access_zone/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества зон доступа.
   * Для пользователей типов owner, employee возвращаются только зоны доступа, относящиеся к компании пользователя.
   * Метод доступен для: admin, service, bti, ltp_first, device_admin, manager, owner, employee
   */
  GetAccessZoneCount = (req?: GetAccessZoneCountRequestDto, init?: RequestInit): Promise<GetAccessZoneCountResponseDto> => {
    return fm.request<GetAccessZoneCountRequestDto, GetAccessZoneCountResponseDto>(`${this.host}/access_control/api/v1/access_zone/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод архивации зоны доступа.
   * Для пользователей типов owner, employee доступны к архивации только зоны доступа, относящиеся к компании пользователя.
   * Метод доступен для: admin, service, bti, ltp_first, device_admin, manager, owner, employee
   */
  DeleteAccessZone = (req: DeleteAccessZoneRequestDto, init?: RequestInit): Promise<DeleteAccessZoneResponseDto> => {
    return fm.request<DeleteAccessZoneRequestDto, DeleteAccessZoneResponseDto>(`${this.host}/access_control/api/v1/access_zone/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод разархивации зоны доступа по идентификатору.
   * Для пользователей типов owner, employee доступны к разархивации только зоны доступа, относящиеся к компании пользователя.
   * Метод доступен для: admin, service, bti, ltp_first, device_admin, manager, owner, employee
   */
  PostAccessZoneRestore = (req: PostAccessZoneRestoreRequestDto, init?: RequestInit): Promise<PostAccessZoneRestoreResponseDto> => {
    return fm.request<PostAccessZoneRestoreRequestDto, PostAccessZoneRestoreResponseDto>(`${this.host}/access_control/api/v1/access_zone/restore/${encodeURIComponent(req.id)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum AccessZonePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type AccessZonePagingDirectionTypeResponseEnum = keyof typeof AccessZonePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type AccessZonePagingDirectionTypeRequestEnum = Exclude<AccessZonePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum AccessZonePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type AccessZonePagingOrderByTypeResponseEnum = keyof typeof AccessZonePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type AccessZonePagingOrderByTypeRequestEnum = Exclude<AccessZonePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Зона доступа.
 * # Описание модели
 */
export type AccessZoneRequestDto = {
  /**
   * Идентификатор зоны доступа.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * # Диапазон: 3..64
   */
  title: string
  /**
   * Описание.
   * # Диапазон: 3..200
   */
  description?: string | null
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt?: string | null
  /**
   * Идентификаторы точек доступа, входящих в зону.
   * Все точки доступа должны принадлежать той же квартирограмме, что и зона.
   * # Тип: Guid.
   * # Диапазон: 0..1000
   */
  accessPointIds?: string[]
}
/**
 * Зона доступа.
 * # Описание модели
 */
export type AccessZoneResponseDto = {
  /**
   * Идентификатор зоны доступа.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * # Диапазон: 3..64
   */
  title: string
  /**
   * Описание.
   * # Диапазон: 3..200
   */
  description: string | null
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime
   */
  readonly deletedAt: string | null
  /**
   * Идентификаторы точек доступа, входящих в зону.
   * Все точки доступа должны принадлежать той же квартирограмме, что и зона.
   * # Тип: Guid.
   * # Диапазон: 0..1000
   */
  accessPointIds: string[]
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type AccessZoneSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: AccessZoneSavingErrorConflictRequestDto
  /**
   * Точка доступа принадлежит другой квартирограмме
   */
  readonly accessPointFlatgrammMismatch: AccessZoneSavingErrorAccessPointFlatgrammMismatchRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type AccessZoneSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: AccessZoneSavingErrorConflictResponseDto
  /**
   * Точка доступа принадлежит другой квартирограмме
   */
  readonly accessPointFlatgrammMismatch: AccessZoneSavingErrorAccessPointFlatgrammMismatchResponseDto
}>
/**
 * Несовпадение квартирограммы точки доступа.
 * Причины:
 * - Точка доступа принадлежит другой квартирограмме — её flatgramm_id не совпадает с flatgramm_id зоны доступа
 */
export type AccessZoneSavingErrorAccessPointFlatgrammMismatchRequestDto = {
  /**
   * Идентификатор точки доступа с несовпадающей квартирограммой.
   * # Тип: Guid
   */
  accessPointId: string
  /**
   * Идентификатор квартирограммы точки доступа.
   * # Диапазон: 1..2147483647
   */
  accessPointFlatgrammId: number
}
/**
 * Несовпадение квартирограммы точки доступа.
 * Причины:
 * - Точка доступа принадлежит другой квартирограмме — её flatgramm_id не совпадает с flatgramm_id зоны доступа
 */
export type AccessZoneSavingErrorAccessPointFlatgrammMismatchResponseDto = {
  /**
   * Идентификатор точки доступа с несовпадающей квартирограммой.
   * # Тип: Guid
   */
  accessPointId: string
  /**
   * Идентификатор квартирограммы точки доступа.
   * # Диапазон: 1..2147483647
   */
  accessPointFlatgrammId: number
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type AccessZoneSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type AccessZoneSavingErrorConflictResponseDto = {
}
/**
 * Фильтр по зонам доступа
 */
export type AccessZoneFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано, поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text?: string | null
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds?: number[]
  /**
   * Включать удалённые записи.
   * Если не передано — удалённые записи не включаются
   */
  showDeleted?: boolean | null
}
/**
 * Фильтр по зонам доступа
 */
export type AccessZoneFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано, поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text: string | null
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds: number[]
  /**
   * Включать удалённые записи.
   * Если не передано — удалённые записи не включаются
   */
  showDeleted: boolean | null
}
/**
 * Постраничный вывод зон доступа
 */
export type AccessZonePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: AccessZonePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: AccessZonePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод зон доступа
 */
export type AccessZonePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: AccessZonePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: AccessZonePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос удаления зоны доступа
 */
export type DeleteAccessZoneRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления зоны доступа
 */
export type DeleteAccessZoneResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteAccessZoneResponseErrorDto
}>
/**
 * Ошибка запроса удаления зоны доступа
 */
export type DeleteAccessZoneResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса удаления зоны доступа
 */
export type DeleteAccessZoneResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение количества зон доступа
 */
export type GetAccessZoneCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: AccessZoneFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества зон доступа
 */
export type GetAccessZoneCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего зон доступа
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetAccessZoneCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества зон доступа
 */
export type GetAccessZoneCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества зон доступа
 */
export type GetAccessZoneCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка зон доступа
 */
export type GetAccessZoneListRequestDto = {
  /**
   * Фильтр
   */
  filter?: AccessZoneFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: AccessZonePagingRequestDto
}>
/**
 * Ответ на запрос получения списка зон доступа
 */
export type GetAccessZoneListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Зона доступа
   */
  readonly data: AccessZoneResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAccessZoneListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка зон доступа
 */
export type GetAccessZoneListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка зон доступа
 */
export type GetAccessZoneListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение зоны доступа по идентификатору
 */
export type GetAccessZoneRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения зоны доступа
 */
export type GetAccessZoneResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Зона доступа
   */
  readonly data: AccessZoneResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAccessZoneResponseErrorDto
}>
/**
 * Ошибка запроса получения зоны доступа
 */
export type GetAccessZoneResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения зоны доступа
 */
export type GetAccessZoneResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на создание/изменение зоны доступа
 */
export type PostAccessZoneRequestDto = {
  /**
   * Зона доступа
   */
  data: AccessZoneRequestDto
}
/**
 * Ответ на запрос на создание/изменение зоны доступа
 */
export type PostAccessZoneResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Зона доступа
   */
  readonly data: AccessZoneResponseDto
  /**
   * Ошибка
   */
  readonly error: PostAccessZoneResponseErrorDto
}>
/**
 * Ошибка запроса сохранения зоны доступа
 */
export type PostAccessZoneResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: AccessZoneSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения зоны доступа
 */
export type PostAccessZoneResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: AccessZoneSavingErrorResponseDto
}>
/**
 * Запрос разархивации зоны доступа по идентификатору
 */
export type PostAccessZoneRestoreRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос разархивации зоны доступа
 */
export type PostAccessZoneRestoreResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostAccessZoneRestoreResponseErrorDto
}>
/**
 * Ошибка запроса разархивации зоны доступа
 */
export type PostAccessZoneRestoreResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса разархивации зоны доступа
 */
export type PostAccessZoneRestoreResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Зона доступа.
   * # Описание модели
   */
  "AccessZone": {
    "kind": "class",
    "text": "Зона доступа.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор зоны доступа.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор зоны доступа.\n# Тип: Guid",
      },
      /**
       * Наименование.
       * # Диапазон: 3..64
       */
      "title": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 3..64",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Описание.
       * # Диапазон: 3..200
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание.\n# Диапазон: 3..200",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 200,
            "message": "Значение не входит в допустимый диапазон. Максимум: 200"
          },
        }
      },
      /**
       * Идентификатор квартирограммы.
       * # Диапазон: 1..2147483647
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime",
      },
      /**
       * Идентификаторы точек доступа, входящих в зону.
       * Все точки доступа должны принадлежать той же квартирограмме, что и зона.
       * # Тип: Guid.
       * # Диапазон: 0..1000
       */
      "accessPointIds": {
        "type": "string",
        "text": "Идентификаторы точек доступа, входящих в зону.\nВсе точки доступа должны принадлежать той же квартирограмме, что и зона.\n# Тип: Guid.\n# Диапазон: 0..1000",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 1000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1000"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "AccessZone.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "AccessZone.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Точка доступа принадлежит другой квартирограмме
       */
      "accessPointFlatgrammMismatch": {
        "type": "AccessZone.SavingError.AccessPointFlatgrammMismatch",
        "text": "Точка доступа принадлежит другой квартирограмме",
      },
    },
  },
  /**
   * Несовпадение квартирограммы точки доступа.
   * Причины:
   * - Точка доступа принадлежит другой квартирограмме — её flatgramm_id не совпадает с flatgramm_id зоны доступа
   */
  "AccessZone.SavingError.AccessPointFlatgrammMismatch": {
    "kind": "class",
    "text": "Несовпадение квартирограммы точки доступа.\nПричины:\n- Точка доступа принадлежит другой квартирограмме — её flatgramm_id не совпадает с flatgramm_id зоны доступа",
    "fields": {
      /**
       * Идентификатор точки доступа с несовпадающей квартирограммой.
       * # Тип: Guid
       */
      "accessPointId": {
        "type": "string",
        "text": "Идентификатор точки доступа с несовпадающей квартирограммой.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор квартирограммы точки доступа.
       * # Диапазон: 1..2147483647
       */
      "accessPointFlatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы точки доступа.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "AccessZone.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Фильтр по зонам доступа
   */
  "AccessZoneFilter": {
    "kind": "class",
    "text": "Фильтр по зонам доступа",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано, поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование;
       * # - Описание
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано, поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование;\n# - Описание",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По идентификаторам квартирограмм
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По идентификаторам квартирограмм",
      },
      /**
       * Включать удалённые записи.
       * Если не передано — удалённые записи не включаются
       */
      "showDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Включать удалённые записи.\nЕсли не передано — удалённые записи не включаются",
      },
    },
  },
  /**
   * Постраничный вывод зон доступа
   */
  "AccessZonePaging": {
    "kind": "class",
    "text": "Постраничный вывод зон доступа",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "AccessZonePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "AccessZonePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос удаления зоны доступа
   */
  "DeleteAccessZoneRequest": {
    "kind": "class",
    "text": "Запрос удаления зоны доступа",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления зоны доступа
   */
  "DeleteAccessZoneResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления зоны доступа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteAccessZoneResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления зоны доступа
   */
  "DeleteAccessZoneResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления зоны доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение количества зон доступа
   */
  "GetAccessZoneCountRequest": {
    "kind": "class",
    "text": "Запрос на получение количества зон доступа",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AccessZoneFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества зон доступа
   */
  "GetAccessZoneCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества зон доступа",
    "fields": {
      /**
       * Всего зон доступа
       */
      "data": {
        "type": "int32",
        "text": "Всего зон доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessZoneCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества зон доступа
   */
  "GetAccessZoneCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества зон доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка зон доступа
   */
  "GetAccessZoneListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка зон доступа",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AccessZoneFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "AccessZonePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка зон доступа
   */
  "GetAccessZoneListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка зон доступа",
    "fields": {
      /**
       * Зона доступа
       */
      "data": {
        "type": "AccessZone",
        "text": "Зона доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessZoneListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка зон доступа
   */
  "GetAccessZoneListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка зон доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение зоны доступа по идентификатору
   */
  "GetAccessZoneRequest": {
    "kind": "class",
    "text": "Запрос на получение зоны доступа по идентификатору",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения зоны доступа
   */
  "GetAccessZoneResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения зоны доступа",
    "fields": {
      /**
       * Зона доступа
       */
      "data": {
        "type": "AccessZone",
        "text": "Зона доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessZoneResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения зоны доступа
   */
  "GetAccessZoneResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения зоны доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на создание/изменение зоны доступа
   */
  "PostAccessZoneRequest": {
    "kind": "class",
    "text": "Запрос на создание/изменение зоны доступа",
    "fields": {
      /**
       * Зона доступа
       */
      "data": {
        "type": "AccessZone",
        "text": "Зона доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание/изменение зоны доступа
   */
  "PostAccessZoneResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание/изменение зоны доступа",
    "fields": {
      /**
       * Зона доступа
       */
      "data": {
        "type": "AccessZone",
        "text": "Зона доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAccessZoneResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения зоны доступа
   */
  "PostAccessZoneResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения зоны доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "AccessZone.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос разархивации зоны доступа по идентификатору
   */
  "PostAccessZoneRestoreRequest": {
    "kind": "class",
    "text": "Запрос разархивации зоны доступа по идентификатору",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос разархивации зоны доступа
   */
  "PostAccessZoneRestoreResponse": {
    "kind": "class",
    "text": "Ответ на запрос разархивации зоны доступа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAccessZoneRestoreResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса разархивации зоны доступа
   */
  "PostAccessZoneRestoreResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса разархивации зоны доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "AccessZonePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "AccessZonePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 4,
        "text": "Дата создания",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 5,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}